/**
 * <Comente>
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.LatLong = (function () {

    function LatLong() {

        Monet.UI.Fields.TextField.apply(this, arguments);

        this.value = '';

        this.createElement = function () {

            this.input =  this.input || document.createElement('input');

            this.input.type = 'text';
            this.input.className = 'latLongField';

            if(this.maxSize){
                this.input.maxLength = this.maxSize;
            }

            this.rootEl.appendChild(this.input);

        };

        this.addEventListeners = function () {

            $(this.input).on("keyup blur focus", function (e) {
                e.preventDefault();
                var expre = /[^0-9.-]/g;
                if ($(this).val().match(expre)) {
                    $(this).val($(this).val().replace(expre, ''));
                }
            });

        };

        this.getValue = function () {

            this.value = this.input.value;
            return this.value;
            
        };

        this.render = function () {

            this.createElement();
            this.setValue(this.value);
            this.addEventListeners();
            return this.rootEl;

        };

    }

    return LatLong;

}());
